import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { useDialog, useLegacyEffect } from "helper/customHook";
import { DIALOG } from "helper/enum/dialogEnum";
import { isOpenDialogSelector } from "redux-store/static/redux/selector";
import { useDispatch, useSelector } from "react-redux";
import pxToRem from "theme/base/pxToRem";

import { ReactComponent as IconCopy } from "assets/svg/20-copy.svg";
import { ReactComponent as IconEdit } from "assets/svg/20-edit.svg";
import { ReactComponent as IconCalendarEdit } from "assets/svg/20-calendar-edit.svg";
import { ReactComponent as IconDelete } from "assets/svg/20-delete.svg";

import { setDeleteRequestData } from "modules/DeclareLeave/redux/deleteRequest";
import {
  getRequestLeaveDetailStart,
  resetRequestLeaveDetail,
  setRequestLeaveDetailId,
} from "modules/DeclareLeave/redux/getRequestLeaveDetail";
import {
  selectRequestLeaveDetailData,
  selectRequestLeaveDetailStatus,
} from "modules/DeclareLeave/redux/selector";
import { ReactComponent as IconClose } from "assets/svg/20-close.svg";

import { formatDateStringToDDMMYYYY } from "helper/utils";
import {
  ApproveStatus,
  ApproveStatusValue,
  IApproveStatus,
  LeaveType,
  statusColor,
  TitleContent,
} from "../../const";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  DialogTitleCustom,
  Title,
} from "modules/PersonnelInformation/Pages/Main/component/modal/style";
import { getListRequestLeaveConfigStart } from "modules/DeclareLeave/redux/getListRequestLeaveConfig";
import { SCREEN } from "helper/roleChecker/Screens";
import {
  formReqLeaveReset,
  resetFormLeaveLongTerm,
} from "modules/DeclareLeave/redux/formReqLeave";
import { DialogActionWrapper } from "../../style";
import EmptyState from "components/common/EmptyState";
import { ReduxStateType } from "redux-store/types";
import ListDocument from "../ListDocument";
import { declareLeaveURL } from "modules/DeclareLeave/Pages/Main/DeclareLeaveContent";
import isString from "lodash/isString";
import { accountInfoDataSelector } from "layouts/Sidenav/redux/selector";
import {
  getEarlyRegistrationDetailStart,
  setEarlyRegistrationDetailId,
} from "modules/DeclareLeave/redux/getEarlyRegistrationDetail";
import { setDeleteEarlyRegistrationId } from "modules/DeclareLeave/redux/deleteEarlyRegistration";
import { setEarlyRegistrationFormInput } from "modules/DeclareLeave/redux/earlyRegistation";
const LeaveRequestDetails = () => {
  const { tab, id: idViewDetail } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { employeeCode } = useSelector(accountInfoDataSelector);

  const dispatch = useDispatch();
  const data = useSelector(selectRequestLeaveDetailData);
  const status = useSelector(selectRequestLeaveDetailStatus);

  useLegacyEffect(() => {
    if (idViewDetail && pathname.includes(`/${declareLeaveURL.leave}`)) {
      dispatch(setRequestLeaveDetailId(idViewDetail));
      dispatch(getRequestLeaveDetailStart());
      requestLeaveDialog.open();
    }
    // return () => {
    //   dispatch(setDeleteRequestData(""));
    // };
  }, [idViewDetail, pathname]);

  const editLeaveDialog = useDialog(DIALOG.REQUEST_LEAVE);
  const requestLeaveDialog = useDialog(DIALOG.VIEW_REQUEST_LEAVE_DETAIL);
  const open = useSelector(
    isOpenDialogSelector(DIALOG.VIEW_REQUEST_LEAVE_DETAIL)
  );
  const approveDialog = useDialog(DIALOG.MODAL_CONFIRM);
  const earlyRegistrationDialog = useDialog(DIALOG.EARLY_REGISTRATION);

  const renderBoxContent = (
    title: string,
    content: string | number,
    hasDivider?: boolean,
    fontWeightContent?: 400 | 500 | 600
  ) => (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      sx={(theme) => ({
        paddingBottom: 1.5,
        borderBottom: hasDivider
          ? `1px solid ${theme.palette.stroke.strokeDefault2}`
          : "none",
        marginBottom: hasDivider ? 1.5 : 0,
      })}
    >
      <Typography
        sx={(theme) => ({
          fontSize: theme.typography.size.sm_14,
          color: theme.palette.text.textSecondary,
          fontWeight: theme.typography.fw_regular_400,
        })}
      >
        {title}
      </Typography>
      <Typography
        sx={(theme) => ({
          fontSize: theme.typography.size.sm_14,
          color:
            title === TitleContent.status
              ? statusColor(theme, content as IApproveStatus, "color")
              : theme.palette.text.textPrimary,
          fontWeight: fontWeightContent ?? theme.typography.fw_regular_400,
        })}
      >
        {title === TitleContent.status ? ApproveStatus[content] : content}
      </Typography>
    </Box>
  );

  const renderLeaveDetails = () =>
    (data?.details ?? []).map((leave, index) => {
      const listLeave = data?.details ?? [];
      const date =
        data?.type === LeaveType.SHORT_TERM
          ? `Ngày ${formatDateStringToDDMMYYYY(leave.fromDate)}`
          : `Từ ${formatDateStringToDDMMYYYY(listLeave[0]?.fromDate)} đến ${formatDateStringToDDMMYYYY(listLeave[listLeave.length - 1]?.toDate)}`;
      if (
        data?.type === LeaveType.SHORT_TERM ||
        (data?.type === LeaveType.LONG_TERM && index === 0)
      ) {
        const hasBorderBottom =
          data?.type === LeaveType.SHORT_TERM && index < listLeave.length - 1;
        return (
          <Box
            key={index}
            sx={(theme) => ({
              display: "flex",
              justifyContent: "space-between",
              paddingY: 1.5,
              borderBottom: hasBorderBottom
                ? `1px solid ${theme.palette.stroke.strokeDefault}`
                : "none",
            })}
          >
            <Box display={"flex"} gap={1.5}>
              <Typography fontSize={14}>{date}</Typography>

              {tab === "order-management" && (
                <Typography
                  fontSize={14}
                  fontWeight={400}
                  sx={(theme) => ({
                    color: theme.palette.text.textSecondary,
                    borderLeft: `1px solid ${theme.palette.stroke.strokeDefault}`,
                    paddingLeft: 1.5,
                  })}
                >
                  {leave.leaveHalfDay ? "Nghỉ nửa ngày" : "Nghỉ cả ngày"}
                </Typography>
              )}
            </Box>
            <Typography
              fontSize={14}
              fontWeight={600}
              sx={{
                color: leave.hexColor,
                textDecoration: "underline",
                textDecorationStyle: "dotted",
                textDecorationColor: leave.hexColor,
              }}
            >
              {leave.reasonName}
            </Typography>
          </Box>
        );
      }
      return null;
    });

  const renderNote = (status: IApproveStatus, note: string) => {
    if (status === ApproveStatusValue.PENDING || !note) return null;
    return renderBoxContent(
      status === ApproveStatusValue.REFUSE ? "Lý do từ chối" : "Ghi chú",
      note
    );
  };

  const handleCopyLink = () => {
    const linkToCopy = window.location.href.replace(
      declareLeaveURL.orderLeave,
      declareLeaveURL.orderManagement
    );
    navigator.clipboard
      .writeText(linkToCopy)
      .then(() => {
        toast.success("Đã sao chép liên kết");
      })
      .catch(() => {
        toast.error("Sao chép liên kết thất bại");
      });
  };
  const onClickEdit = () => {
    const month = data.details[0].fromDate.split("-")[1];
    const year = data.details[0].fromDate.split("-")[0];

    dispatch(
      getListRequestLeaveConfigStart({ month, year, screenCode: SCREEN.IP_015 })
    );
    closeModal();
    editLeaveDialog.open();
  };

  const closeModal = () => {
    requestLeaveDialog.close();
    const newURL = pathname.replace(`/${idViewDetail}`, "");
    navigate(newURL, { replace: true });
  };

  const handleClose = () => {
    dispatch(formReqLeaveReset());
    dispatch(resetFormLeaveLongTerm());
    dispatch(resetRequestLeaveDetail());
    closeModal();
  };

  const handleViewDetailEarlyRegistration = (id) => {
    const newURL = pathname.replace(
      `/${declareLeaveURL.leave}/${idViewDetail}`,
      `/${declareLeaveURL.earlyRegistration}/${id}`
    );
    navigate(newURL, { replace: true });

    dispatch(setEarlyRegistrationDetailId(id));
    dispatch(setDeleteEarlyRegistrationId(id));
    dispatch(getEarlyRegistrationDetailStart());
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitleCustom>
        <Title>Chi tiết đơn xin nghỉ</Title>
        <IconButton onClick={handleClose}>
          <IconClose />
        </IconButton>
      </DialogTitleCustom>
      {isString(data) && status !== ReduxStateType.INIT && (
        <DialogContent>
          <EmptyState message={data} />
        </DialogContent>
      )}
      {status === ReduxStateType.SUCCESS && (
        <>
          <DialogContent
            sx={(theme) => ({
              background: theme.palette.background.bgTertiary,
              p: 0,
            })}
          >
            <Box
              sx={(theme) => ({
                margin: 2,
                padding: pxToRem(20),
                background: "white",
                borderRadius: pxToRem(8),
              })}
            >
              <Box mb={2}>
                <Typography gutterBottom>
                  Ngày tạo đơn:{" "}
                  {formatDateStringToDDMMYYYY(data?.registerDate ?? "")}
                </Typography>
              </Box>
              {(data?.relatedPersons ?? [])
                .map((i) => i.value)
                .includes(employeeCode) && (
                <>
                  {renderBoxContent(
                    TitleContent.employeeName,
                    data?.employeeName
                  )}
                  {renderBoxContent(
                    "",
                    `${data?.positionName} - ${data?.departmentName}`
                  )}
                </>
              )}
              <Box mt={2} mb={pxToRem(20)}>
                <Typography
                  sx={(theme) => ({
                    fontSize: theme.typography.size.sm_14,
                    color: theme.palette.text.textSecondary,
                    fontWeight: theme.typography.fw_regular_400,
                  })}
                  mb={1}
                >
                  Thông tin ngày nghỉ
                </Typography>
                <Box
                  sx={(theme) => ({
                    border: `1px solid ${theme.palette.stroke.strokeDefault}`,
                    borderRadius: pxToRem(8),
                    paddingX: 2,
                    paddingY: 0.5,
                  })}
                >
                  {renderLeaveDetails()}
                </Box>
              </Box>
              {renderBoxContent(
                TitleContent.totalLeave,
                `${data?.totalLeaveDay ?? 0} ngày`
              )}
              {renderBoxContent(TitleContent.leaveReason, data?.leaveReason)}
              {renderBoxContent(
                TitleContent.relatedPerson,
                (data?.relatedPersons ?? []).map((i) => i.label).join(", "),
                true
              )}

              {data?.approvals?.map((approval, index) => (
                <>
                  {renderBoxContent(
                    `${TitleContent.approval} (${index + 1})`,
                    `${approval.approverName} - ${ApproveStatus[approval.approveStatus]}`
                  )}
                  {renderNote(approval.approveStatus, approval.refuseReason)}
                </>
              ))}
              {renderBoxContent(
                TitleContent.status,
                data?.finalApproveStatus,
                false,
                600
              )}

              {renderBoxContent(
                TitleContent.approvalDate,
                data?.finalApproveDate
                  ? formatDateStringToDDMMYYYY(data?.finalApproveDate)
                  : "---"
              )}
              {data?.note && renderBoxContent("Ghi chú", data?.note)}
              {(data?.attachedFiles ?? []).length > 0 && (
                <Box mb={1}>
                  <Typography
                    sx={(theme) => ({
                      fontSize: theme.typography.size.sm_14,
                      color: theme.palette.text.textSecondary,
                      fontWeight: theme.typography.fw_regular_400,
                    })}
                  >
                    File đính kèm
                  </Typography>
                  <Box display={"flex"} maxWidth={"inherit"} overflow={"auto"}>
                    {(data?.attachedFiles ?? []).map((document, index) => (
                      <ListDocument key={index} content={document} />
                    ))}
                  </Box>
                </Box>
              )}

              <Button
                variant="outlined"
                color="primary"
                sx={{ width: "100%" }}
                onClick={handleCopyLink}
              >
                <IconCopy />
                <Typography
                  sx={(theme) => ({
                    color: theme.palette.text.textLink,
                    fontWeight: theme.typography.fw_semibold_600,
                    ml: 1,
                  })}
                >
                  Sao chép liên kết
                </Typography>
              </Button>
            </Box>
          </DialogContent>

          <DialogActions
            sx={{ justifyContent: "space-evenly", px: 3, pb: 2, gap: 2 }}
          >
            <DialogActionWrapper
              sx={{
                display: "flex",
                justifyContent: "space-evenly",
                gap: 1,
                alignItems: "center",
              }}
            >
              <Button
                variant="blur"
                fullWidth
                sx={(theme) => ({
                  background: theme.palette.background.bgSecondary,
                  color: theme.palette.text.textPrimary,
                  fontSize: pxToRem(14),
                })}
                onClick={handleClose}
              >
                Đóng
              </Button>
              <Button
                variant="blur"
                color="primary"
                fullWidth
                disabled={!data?.editable}
                onClick={onClickEdit}
                sx={(theme) => ({
                  fontSize: pxToRem(14),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: pxToRem(2),
                })}
              >
                <IconEdit />
                <span>Chỉnh sửa</span>
              </Button>
              {(data?.insertRegisterEarly || data?.registerEarlyId) && (
                <Button
                  variant="blur"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    dispatch(
                      setEarlyRegistrationFormInput({
                        registerLeaveId: idViewDetail,
                      })
                    );
                    if (data?.registerEarlyId) {
                      handleViewDetailEarlyRegistration(data?.registerEarlyId);
                    } else {
                      const newURL = pathname.replace(`/${idViewDetail}`, "");
                      navigate(newURL, { replace: true });
                    }
                    earlyRegistrationDialog.open();
                    requestLeaveDialog.close();
                  }}
                  sx={(theme) => ({
                    fontSize: pxToRem(14),
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: pxToRem(1),
                  })}
                >
                  <IconCalendarEdit />
                  <span>Đi làm sớm</span>
                </Button>
              )}

              <Button
                fullWidth
                variant="blur"
                color="error"
                sx={{
                  fontSize: pxToRem(14),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: pxToRem(2),
                }}
                disabled={!data?.delete}
                onClick={() => {
                  dispatch(setDeleteRequestData(data?.id));
                  closeModal();
                  approveDialog.open();
                }}
              >
                <IconDelete />
                <span>Xóa</span>
              </Button>
            </DialogActionWrapper>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default LeaveRequestDetails;
